"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _FAEText = require("../FAEText/FAEText");

var _FAEContainer = require("../FAEContainer/FAEContainer");

require("./FAEFooter.scss");

const _excluded = ["links", "socialLinks", "expertLogo", "className", "justify", "align", "expertLogoClicked"],
      _excluded2 = ["label", "href"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEFooter = _ref => {
  let {
    links = [],
    socialLinks = [],
    expertLogo,
    className = "",
    justify,
    align,
    expertLogoClicked
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "fae--footer-main-container ".concat(className)
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--footer-content-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--footer-links"
  }, links.map((link, index) => {
    const {
      label,
      href = ""
    } = link,
          rest = _objectWithoutProperties(link, _excluded2);

    return href === "" ? /*#__PURE__*/_react.default.createElement("p", _extends({}, rest, {
      className: "fae--footer-link",
      key: index
    }), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, null, label)) : /*#__PURE__*/_react.default.createElement("a", {
      key: index,
      className: "fae--footer-link",
      target: "_blank",
      href: href,
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, null, label));
  })), socialLinks.length !== 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--footer-social-links"
  }, socialLinks.map((link, index) => {
    const {
      icon,
      href
    } = link;
    return /*#__PURE__*/_react.default.createElement("a", {
      key: index,
      className: "fae--social-link",
      target: "_blank",
      href: href,
      rel: "noreferrer"
    }, icon);
  }))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--expert-icon-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: expertLogoClicked,
    className: "fae--logo-image"
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: "100%",
    width: "100%",
    src: expertLogo,
    alt: "expert-logo"
  })), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, null, "\xA9 ", new Date().getFullYear(), " ", /*#__PURE__*/_react.default.createElement("a", {
    style: {
      textDecoration: "none",
      color: "black"
    },
    href: "https://www.selteq.net/",
    target: "_black"
  }, "Selteq Ltd.", " "))))));
};

exports.FAEFooter = FAEFooter;